import { IMachine } from '../../../interfaces/Machine.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetMachineByIdParams {
  machineId: string;
}

export const getMachineById = ({ machineId }: IGetMachineByIdParams): Promise<IMachine> => {
  return customAxios.get(`/machines/${machineId}`);
};
